__turbopack_context__.v({
  "activeTab": "blogTabs-module-scss-module__nSxr_W__activeTab",
  "blogTabs": "blogTabs-module-scss-module__nSxr_W__blogTabs",
  "tabItem": "blogTabs-module-scss-module__nSxr_W__tabItem",
  "tabsWrapper": "blogTabs-module-scss-module__nSxr_W__tabsWrapper",
});
